import { c as _c } from "react/compiler-runtime";
import { FileIcon, useDownloadFile } from '@newfront-insurance/admin-ui/files';
import type { GeneratedFileInfo } from '@newfront-insurance/ai-api';
import { cn } from '@newfront-insurance/core-ui/v2';
import type { ToolUIPart } from 'ai';
interface ToolInvocationPart {
  type: string;
  state?: string;
  toolCallId?: string;
  output?: {
    files?: Array<{
      fileId: string;
      filename: string;
      containerId: string;
    }>;
    containerId?: string;
    image?: {
      mediaType: string;
      base64Data: string;
    };
    generatedFileUuids?: string[];
    generatedFiles?: Array<GeneratedFileInfo>;
  };
}

/**
 * Helper function to render generated files from tool output
 */
function renderGeneratedFiles(output: ToolInvocationPart['output']): React.ReactNode | null {
  if (!output) return null;

  // Use generated files from Files service
  if (output.generatedFiles && output.generatedFiles.length > 0) {
    const generatedFiles = output.generatedFiles.map(file => ({
      uuid: file.fileUuid,
      filename: file.filename
    }));
    return <GeneratedFilesList files={generatedFiles} />;
  }

  // Fallback to generatedFileUuids
  if (output.generatedFileUuids && output.generatedFileUuids.length > 0) {
    const generatedFiles = output.generatedFileUuids.map((uuid, idx) => ({
      uuid,
      filename: `Generated file ${idx + 1}`
    }));
    return <GeneratedFilesList files={generatedFiles} />;
  }
  return null;
}
interface ProcessFilesToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering processFiles tool output.
 */
export function ProcessFilesTool({
  part
}: ProcessFilesToolProps) {
  // Handle output
  if (part.state === 'output-available' && (part as ToolInvocationPart).output) {
    return renderGeneratedFiles((part as ToolInvocationPart).output);
  }
  return null;
}
export function GeneratedFilesList(t0) {
  const $ = _c(5);
  const {
    files
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-muted-foreground text-sm font-medium">Generated Files:</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== files) {
    t2 = files.map(_temp);
    $[1] = files;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex flex-col gap-2">{t1}<div className="flex flex-row flex-wrap gap-2">{t2}</div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(file) {
  return <ChatFileListItem key={file.uuid} file={file} />;
}
function ChatFileListItem(t0) {
  const $ = _c(17);
  const {
    file
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    download,
    isDownloading
  } = useDownloadFile(t1);
  let t2;
  if ($[1] !== download || $[2] !== file.uuid) {
    t2 = () => {
      download(file.uuid);
    };
    $[1] = download;
    $[2] = file.uuid;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClick = t2;
  let t3;
  if ($[4] !== handleClick) {
    t3 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleClick();
      }
    };
    $[4] = handleClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isDownloading) {
    t4 = cn("flex w-fit max-w-xs cursor-pointer items-center gap-2 rounded-sm px-1 py-1", "hover:bg-muted/50 transition-colors", {
      "pointer-events-none opacity-50": isDownloading
    });
    $[6] = isDownloading;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] !== file.filename) {
    t5 = <FileIcon filename={file.filename} hasBackground={false} />;
    t6 = <span className="text-steel-400 truncate text-xs">{file.filename}</span>;
    $[8] = file.filename;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleClick || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div role="button" tabIndex={0} onClick={handleClick} onKeyDown={t3} className={t4}>{t5}{t6}</div>;
    $[11] = handleClick;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}